const tabId = Date.now() + '-' + Math.random();
sessionStorage.setItem('tabId', tabId);

let loginCallback = null;
let dataReceived = false;

function isLeader() {
	return localStorage.getItem('leaderTab') === tabId;
}

function claimLeadership() {
	if (
		!localStorage.getItem('leaderTab') ||
		Date.now() - parseInt(localStorage.getItem('leaderHeartbeat'), 10) > 5000 ||
		sessionStorage.length > 8
	) {
		localStorage.setItem('leaderTab', tabId);
		sendHeartbeat();
	}
}

function sendHeartbeat() {
	if (isLeader()) {
		localStorage.setItem('leaderHeartbeat', Date.now().toString());
	}
}

window.addEventListener('storage', (event) => {
	switch (event.key) {
		case 'leaderTab':
			// Another tab became the leader
			break;

		case 'leaderHeartbeat':
			// No specific action needed for heartbeat updates
			return;

		case 'sessionData':
			if (event.newValue && sessionStorage.length < 8) {
				dataReceived = true;
				const sessionData = JSON.parse(event.newValue);
				updateSessionStorage(sessionData);
				localStorage.removeItem('sessionData');
				if (loginCallback) {
					loginCallback(sessionData);
				}
			}
			break;

		case 'logoutEvent':
			if (
				!['/', '/login', '/dashboard/main', '/agents/history'].includes(
					window.location.pathname
				)
			) {
				sessionStorage.setItem(
					'prevPage',
					window.location.pathname + window.location.search
				);
			}

			handleLogout();
			break;

		case 'requestSession':
			const sessionData = getSessionDataFromStorage();
			if (
				isLeader() &&
				localStorage.getItem('requestSession') !== null &&
				sessionData?.needs_2fa_verification !== 'true'
			) {
				localStorage.removeItem('sessionData');
				broadcastSessionData();
				localStorage.removeItem('requestSession');
			}
			break;

		default:
			break;
	}
});

function handleLogout() {
	clearSessionStorage();
}

setInterval(() => {
	if (isLeader()) {
		sendHeartbeat();
	} else {
		claimLeadership();
	}
}, 1000);

function broadcastSessionData() {
	const sessionData = getSessionDataFromStorage();
	localStorage.setItem('sessionData', JSON.stringify(sessionData));
}

function getSessionDataFromStorage() {
	const keys = [
		'authenticated_in_prev_check',
		'authenticated_in_current_check',
		'token_expiry_date',
		'token',
		'is_impersonation',
		'user_claims',
		'user_id',
		'user_name',
		'user_surname',
		'user_email',
		'user_created_at',
		'merchant_name',
		'merchant_id',
		'merchant_created_at',
		'needs_2fa_verification',
	];
	const sessionData = {};
	keys.forEach((key) => {
		const value = sessionStorage.getItem(key);
		if (value !== null) {
			sessionData[key] = value;
		}
	});
	return sessionData;
}

function updateSessionStorage(sessionData) {
	Object.keys(sessionData).forEach((key) => {
		sessionStorage.setItem(key, sessionData[key]);
	});
}

function clearSessionStorage() {
	const keys = Object.keys(getSessionDataFromStorage());
	keys.forEach((key) => {
		sessionStorage.removeItem(key);
	});
}

// If tab login we broadcast
export function broadcastLoginAndSync() {
	broadcastSessionData();
}

// If tab logout we broadcast
export function broadcastLogoutAndSync() {
	localStorage.setItem('logoutEvent', Date.now());
}

// Once the tab is open she wont have the session data, so we use this to redirect the user to dashboard
export function registerLoginListener(callback) {
	loginCallback = callback;
}

// If the tab is open and the session is not available we request the session from the leader
export function requestSharedSession() {
	localStorage.setItem('requestSession', Date.now());
}

export function isLeaderAvailable() {
	return localStorage.getItem('leaderTab') !== null;
}

export async function awaitLeader() {
	const start = Date.now();
	requestSharedSession();
	while (!dataReceived && Date.now() - start < 1000) {
		await new Promise((resolve) => setTimeout(resolve, 100));
	}
	if (!dataReceived) {
		localStorage.removeItem('leaderTab');
		return false;
	}
}
